import styled from 'styled-components';
import Button from '@@Components/Buttons/Button';
export const ErrorStatusContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url('${props => props.url}');
  background-position: center;
  background-repeat: no-repeat;
  background-size: auto 100%;
  width: 100vw;
  height: 100vh;
  @media screen and (min-width: 1501px) {
    background-size: cover;
  }
  @media screen and (max-height: 900px) {
    background-size: cover;
  }
`;
export const ContentContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 80%;
  color: ${props => props.theme.colors.textSecondary};
  ${props => props.theme.mixins.mobile(`
    width: 95%;
  `)}
`;
export const Title = styled.h1 `
  font-size: 220px;
  line-height: 50px;
  padding-bottom: 110px;
  @media screen and (max-width: 1201px) {
    font-size: 190px;
    padding-bottom: 90px;
  }
  ${props => props.theme.mixins.mobile(`
    font-size: 180px;
  `)}
  @media screen and (max-width: 700px) {
    font-size: 130px;
    padding-bottom: 60px;
  }
`;
export const Subtitle = styled.h2 `
  font-size: 40px;
  line-height: 50px;
  padding-bottom: 20px;
  text-align: center;
  ${props => props.theme.mixins.mobile(`
    font-size: 30px;
  `)}
  @media screen and (max-width: 700px) {
    font-size: 24px;
  }
`;
export const Information = styled.p `
  font-size: 16px;
  line-height: 26px;
  padding-bottom: 20px;
  margin:0;
  text-align: center;
  ${props => props.theme.mixins.mobile(`
    font-size: 14px;
  `)}
`;
export const StyledButton = styled(Button) `
  margin-top: 20px;
  width: 210px;
`;
